module.exports = __webpack_public_path__ + "de77a722/img/revit-icon.5ff0d581.svg";